module.exports = __webpack_public_path__ + "img/blurred-logo.f5ac81c0.png";